<template>
  <div class="noAccess_box">
  
      抱歉  您无权访问此页面！
  </div>
</template>

<script>
export default {
  name: "noAccess",
  data() {
    return {
      serve: this.$store.state.serve
    };
  }
};
</script>

<style lang="scss">
.noAccess_box {
  width: 1000px;
  min-height: 600px;
  margin: 0 auto;
  padding: 100px 0 0 0px;
  font-size: 30px;
  color: red;
  text-align: center;
  padding-top: 12%;
  background: url('../assets/images/indexlogo.png') top no-repeat;
}
</style>